import React, { useEffect } from "react";
import LabeledDropdown from "../shared/LabeledDropdown";
import { timeUnitOptions } from "../../utils/constants";
import { useFilterStore } from "../../store/filterStore";
import { useInstanceStore } from "../../store/useInstanceStore";
import {
  getOperatingSystems,
  getPaymentModal,
  getRegions,
} from "../../utils/utils";

const Filter: React.FC = () => {
  const region = useFilterStore((state) => state.region);
  const setRegion = useFilterStore((state) => state.setRegion);

  const pricingModel = useFilterStore((state) => state.pricingModel);
  const setPricingModel = useFilterStore((state) => state.setPricingModel);

  const operatingSystem = useFilterStore((state) => state.operatingSystem);
  const setOperatingSystem = useFilterStore(
    (state) => state.setOperatingSystem
  );

  const timeUnit = useFilterStore((state) => state.timeUnit);
  const setTimeUnit = useFilterStore((state) => state.setTimeUnit);

  const providerType = useInstanceStore((state) => state.providerType);

  // --- Dynamic dropdown options ---
  const regionOptions = getRegions(providerType);
  const pricingModelOptions = getPaymentModal(providerType);
  const operatingSystemOptions = getOperatingSystems(providerType);

  // --- Set default dropdown selections ---
  useEffect(() => {
    if (!region && regionOptions.length) {
      setRegion(regionOptions[0].value);
    }
    if (!pricingModel && pricingModelOptions.length) {
      setPricingModel(pricingModelOptions[0].value);
    }
    if (!operatingSystem && operatingSystemOptions.length) {
      setOperatingSystem(operatingSystemOptions[0].value);
    }
  }, [
    providerType,
    region,
    pricingModel,
    operatingSystem,
    regionOptions,
    pricingModelOptions,
    operatingSystemOptions,
    setRegion,
    setPricingModel,
    setOperatingSystem,
  ]);

  return (
    <div className="flex flex-wrap gap-4 w-full pb-4 border-b border-gray-200 bg-white">
      <LabeledDropdown
        id="region"
        label="Region"
        value={region}
        options={regionOptions}
        onChange={setRegion}
        className="flex-1 min-w-[200px]"
        selectClassName="w-full px-3 py-2 pr-8 text-sm text-gray-800 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200"
      />

      <LabeledDropdown
        id="pricing-model"
        label="Pricing Model"
        value={pricingModel}
        options={pricingModelOptions}
        onChange={setPricingModel}
        className="flex-1 min-w-[180px]"
        selectClassName="w-full px-3 py-2 pr-8 text-sm text-gray-800 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200"
      />

      <LabeledDropdown
        id="operating-system"
        label="Operating System"
        value={operatingSystem}
        options={operatingSystemOptions}
        onChange={setOperatingSystem}
        className="flex-1 min-w-[200px]"
        selectClassName="w-full px-3 py-2 pr-8 text-sm text-gray-800 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200"
      />

      <LabeledDropdown
        id="time-unit"
        label="Time Unit"
        value={timeUnit}
        options={timeUnitOptions}
        onChange={setTimeUnit}
        className="flex-1 min-w-[180px]"
        selectClassName="w-full px-3 py-2 pr-8 text-sm text-gray-800 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200"
      />
    </div>
  );
};

export default Filter;
